import React, { useEffect, useState } from 'react'
import Icon from '../../utils/components/atoms/Icon'
import Modal from '../../utils/components/molecules/Modal'

interface ProductValueProps {
  title: string
  className: string
  blocks: { heading: string; description: string; modalCopy:string; }[]
}

const ValueProps: React.FC<ProductValueProps> = ({ title, className, blocks }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }
  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        const modal = document.getElementById('warranty-modal');
        if (modal) {
          modal.focus();
        }
      }, 100); // Increased timeout to ensure modal is fully rendered
      return () => clearTimeout(timer);
    }
  }, [isModalOpen]);
  return (
    <div className="container pt-6">
      <div>
        <span className="text-black body-xs font-semibold pb-6">{title}</span>
        {blocks.map((block, index) => (
          <div key={index} className={`flex items-center ${index < blocks.length - 1 ? 'pb-6' : ''}`}>
            <span dangerouslySetInnerHTML={{ __html: block.heading }}></span>
            {block.description === "<p>Lifetime warranties</p>" ? (
              <>
                <div className={className} dangerouslySetInnerHTML={{ __html: block.description }}/>
                &nbsp;
                <button
                  aria-label="Open Modal with Information on Lifetime warranties"
                  className="w-4 h-4"
                  type="button"
                  onClick={() => openModal()}>
                  <Icon name="question"
                        aria-label="View Lifetime Warranties Information"
                        aria-expanded={isModalOpen}
                        aria-controls="Lifetime Warranty Information"
                        aria-haspopup="dialog" />
                </button>
                <Modal isOpen={isModalOpen} onClose={closeModal}>
                  <div className="relative rounded-b-lg bg-white mt-5 w-full min-w-36 min-h-36" id="warranty-modal" role="dialog" aria-modal="true" aria-label="Information on Lifetime Warranties" aria-expanded="true" tabIndex={-1}>
                    <div className="flex py-12 px-8">
                      <div className="text-center" dangerouslySetInnerHTML={{ __html: block.modalCopy }}/>
                    </div>
                  </div>
                </Modal>
              </>
            ) : (
              <div className={className} dangerouslySetInnerHTML={{ __html: block.description }} />

            )
            }
          </div>
        ))}
      </div>
    </div>
  )
}

export default ValueProps
